import strawberry from '../../../../../model/strawberry.glb'
import PositionFrut from './multiFrut';

function Strawberries() {
    return (<>
        <PositionFrut model={strawberry} minHeight={-15} maxHeight={-37} scale={100}/>
    </>);
}

export default Strawberries;